<template>
  <!--<div>-->
  	<el-row>
  		<el-col :span="4">
  			<i class="el-icon-arrow-left" @click="back"></i>
  		</el-col>
  		<el-col :span="16">
  			<div class="overflow">
  				{{title}}
  			</div>
  		</el-col>
  		<el-col :span="4" >
  				<i @click="jumpSY" class="fa fa-home" aria-hidden="true"></i>
  		</el-col>
  	</el-row>
</template>
<script>
	export default({
		name:'Eheader',
		props:{
			title:{
				type:String,
			}
		},
		methods:{
			back(){
				this.$router.go(-1);
			},
			jumpSY(){
				console.log("首页");
				this.$router.replace("/main");
			}
		}
	})
</script>

<style>
	.el-header{
        position: fixed;
        width: 100%;
        z-index:1000;
        height: 50px!important;
        line-height: 50px;
        font-size: 18px;
        background-color: white;
        text-align: center;
        padding: 0;
    		border-bottom: 1px solid #f4f4f4;
    		color: #7683A1;
    }
    .el-header .overflow{
    	text-overflow: ellipsis;
    	overflow: hidden;
    	white-space: nowrap;    	
    }
    .a{
    	text-decoration: none;
    	color: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/components/template/eheader.vue